import { render, staticRenderFns } from "./AddLoanTierComponent.vue?vue&type=template&id=b13888d2&"
import script from "./AddLoanTierComponent.vue?vue&type=script&lang=js&"
export * from "./AddLoanTierComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports